import moment from 'moment';

const getCurrentFiscalYear = {
  methods: {
    getCurrentFiscalYear(date) {
      if (date) {
        const creationDate = moment(date).format('YYYY-MM-DD');
        const currentYearByCreationDate = moment(creationDate)
          .add((new Date())
            .getFullYear() - moment(creationDate)
            .year(), 'years')
          .format('YYYY-MM-DD');
        return `${this.$t('date.From')} ${currentYearByCreationDate} ${this.$t('date.to')} ${moment(currentYearByCreationDate).add(1, 'y').subtract(1, 'd').format('YYYY-MM-DD')}`; // eslint-disable-line max-len
      }
      return null;
    },
    currentFiscalYear(date) {
      if (date) {
        const creationDate = moment(date).format('YYYY-MM-DD');
        const creationYear = moment(creationDate)
          .add((new Date())
            .getFullYear() - moment(creationDate)
            .year(), 'years');
        if (creationYear.isBefore(new Date())) {
          return creationYear.add(1, 'years');
        }
      }
      return null;
    },
  },
};

export default getCurrentFiscalYear;



// WEBPACK FOOTER //
// ./src/mixins/getCurrentFiscalYear.js